import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PageContentProps extends PropsWithChildren {
  className?: string
}

export function PageContent({ children, className }: PageContentProps) {
  return <div className={cn('px-13 py-10', className)}>{children}</div>
}
